document.addEventListener("DOMContentLoaded", function () {
  const sliders = document.querySelectorAll(".cs-icon-boxes-mobile.swiper");

  sliders.forEach(function (slider) {
    const slidesMobile = parseInt(slider.dataset.slidesMobile) || 1;
    const slidesTablet = parseInt(slider.dataset.slidesTablet) || 3;
    const slidesDesktop = parseInt(slider.dataset.slidesDesktop) || 5;
    const delay = parseInt(slider.dataset.delay) || 3000;

    new Swiper(slider, {
      loop: true,
      autoplay: {
        delay: delay,
        disableOnInteraction: false
      },
      pagination: {
        el: slider.querySelector(".swiper-pagination"),
        clickable: true
      },
      breakpoints: {
        0: {
          slidesPerView: slidesMobile
        },
        768: {
          slidesPerView: slidesTablet
        },
        1025: {
          slidesPerView: slidesDesktop
        }
      },
      spaceBetween: 20
    });
  });
});
